export default __webpack_public_path__ + "static/media/batchList.9cc66f5c.svg";